import React from 'react';

interface UserStatsCardProps {
  title: string;
  totalCount: number;
  icon?: React.ReactNode;
  breakdown?: {
    admin: number;
    packer: number;
    receiver: number;
    security: number;
  };
}

const UserStatsCard: React.FC<UserStatsCardProps> = ({
  title,
  totalCount,
  icon,
  breakdown,
}) => {
  const formatValue = (val: number) => {
    // Check if val is a valid number
    if (typeof val !== 'number' || isNaN(val) || !isFinite(val)) {
      return '0';
    }
    
    try {
      return val.toLocaleString();
    } catch (error) {
      return val.toString();
    }
  };

  return (
    <div className="card h-100 fade-in card-wrap">  
      <div className="card-body p-2 card-content">
        {/* Title at top left */}
        <h6 className="d-flex mb-3 text-primary card-title align-items-center gap-1">
          {title}: <span className="card-totalCount">{formatValue(totalCount)}</span> {icon && <span className='ms-1'>{icon}</span>}
        </h6>

        {/* Breakdown by roles */}
        {breakdown && (
          <div className="mt-3">
            <div className="row g-2">
              <div className="col-3 text-center">
                <div className="text-primary">
                  <h5 className="mb-1 card-count">{formatValue(breakdown.admin)}</h5>
                  <p className='m-0 text-primary card-label'>Admin</p>
                </div>
              </div>
              <div className="col-3 text-center">
                <div className="text-primary">
                <h5 className="mb-1 card-count">{formatValue(breakdown.packer)}</h5>
                  <p className='m-0 text-primary card-label'>Packer</p>
                </div>
              </div>
              <div className="col-3 text-center">
                <div className="text-primary">
                <h5 className="mb-1 card-count">{formatValue(breakdown.receiver)}</h5>
                  <p className='m-0 text-primary card-label'>Receiver</p>
                </div>
              </div>
              <div className="col-3 text-center">
                <div className="text-primary">
                <h5 className="mb-1 card-count">{formatValue(breakdown.security)}</h5>
                  <p className='m-0 text-primary card-label'>Security</p>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default UserStatsCard;
